import React from "react";
import PageWrapper from "../PageWrapper";

export default function ApplicationEndedPage() {
  return (
    <PageWrapper>
      <div className="p-col-12">
        <blockquote style={{ textAlign: "center" }}>
          The application deadline has passed.
        </blockquote>
      </div>
    </PageWrapper>
  );
}
